import { useEffect } from "react";

type PageMeta = {
  title: string;
  description?: string;
  canonicalPath?: string;
  image?: string;
};

const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href: string) => {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

export const useBlogPageMeta = ({ title, description, canonicalPath, image }: PageMeta) => {
  useEffect(() => {
    document.title = title;
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("property", "og:type", "article");
    upsertMeta("name", "twitter:card", "summary_large_image");

    const origin = window.location.origin;
    const canonical = `${origin}${canonicalPath || window.location.pathname}`;
    upsertCanonical(canonical);
    upsertMeta("property", "og:url", canonical);

    if (image) {
      const absoluteImage = image.startsWith("http") ? image : `${origin}${image}`;
      upsertMeta("property", "og:image", absoluteImage);
      upsertMeta("name", "twitter:image", absoluteImage);
    }
  }, [title, description, canonicalPath, image]);
};
